import {gql} from 'apollo-angular';

export const GET_ALL_SCHOOL_SUBJECTS = gql`
  query GetAllSchoolSubjects {
    schoolSubjects {id, name, abbreviation}
  }
`;


